import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import "./sokoban.scss";
import levelsData from "./SokobanLevels";
const levels = levelsData.levels;
const passwords = levelsData.passwords;

const ww = 19;
const hh = 16;
const pw = 32;
const ph = 32;

export default class Sokoban extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            level: 0
        };
    }

    componentDidMount() {
        const {level} = this.state;
        this.setState({}, () => {
            this.initLevel(level);
        });
    }

    initLevel = (number) => {
        const board = levels[number];

        let gameBoard = [];
        let player;
        let rocks = 0;
        for (let y = 0; y < hh; y++) {
            gameBoard[y] = [];
            for (let x = 0; x < ww; x++) {
                const i = board[y][x];
                if (i === '#') {
                    player = {x, y};
                    gameBoard[y][x] = " ";
                } else {
                    gameBoard[y][x] = i;
                    if (i === 'a') {
                        rocks++;
                    }
                }
            }
        }

        this.setState({
            board: gameBoard,
            player,
            rocks,
            level: number
        });
        ReactDOM.findDOMNode(this.refs.board).focus();
    };

    renderGradient = (i, color) => {
        return <radialGradient id={`g${i}`} cx="0.3" cy="0.3" r="1.0" fx="0.3" fy="0.3">
            <stop offset="0%" stopColor={color}/>
            <stop offset="100%" stopColor="rgb(200, 200, 200)"/>
        </radialGradient>
    };

    renderGradients = () => {
        return <defs>
            <filter id="innerbevel" x="0%" y="0%" width="100%" height="100%">
                <feGaussianBlur stdDeviation="0 0" result="glow"></feGaussianBlur>
                <feMerge>
                    <feMergeNode in="glow"></feMergeNode>
                    <feMergeNode in="glow"></feMergeNode>
                    <feMergeNode in="glow"></feMergeNode>
                </feMerge>
            </filter>
            {this.renderGradient(1, "blue")}
            {this.renderGradient(2, "red")}
            {this.renderGradient(3, "green")}
            {this.renderGradient(4, "orange")}
        </defs>
    };

    renderPlayer = (player) => {
        const {x, y} = player;

        return <g key="player">
            <g key="111" fill="purple" transform={`translate(${x * pw - 2},${y * ph}) scale(0.035,0.03)`}><path d="M500,206c54.1,0,98-43.9,98-98c0-54.1-43.9-98-98-98s-98,43.9-98,98C402,162.1,445.9,206,500,206z M792.9,577.6c-18.9-87-51.8-229.7-100.1-288.8C646,231.3,551.5,228.9,500,228.9l0,0c-51.5,0-146,2.4-192.9,59.9c-48.2,59.1-81.2,201.8-100.1,288.8c-10.4,48.2,56.5,65.9,74,17.4c26-72.2,46.1-132.8,90.1-183.1C394.4,554.3,309,802.2,304,941c0,27,22,49,49,49c20.9,0,38.7-13,45.8-31.5C421.2,880.8,500,664.4,500,664.4l0,0l0,0c0,0,78.8,216.4,101.2,294.1C608.3,977,626.1,990,647,990c27,0,49-22,49-49c-5-138.8-90.4-386.7-67.2-529.1c44,50.3,64.1,110.9,90.1,183.1C736.3,643.4,803.4,625.7,792.9,577.6L792.9,577.6z"/></g>
        </g>;
    };

    checkNextLevel = () => {
        const {rocks} = this.state;
        if (rocks === 0) {
            this.nextLevel();
        }
    };

    movePlayer = (rx, ry) => {
        const {rocks, player, board} = this.state;

        const i = board[player.y + ry][player.x + rx];
        if (i === ' ' || i === 'x') {
            this.setState({
                player: {
                    x: player.x + rx,
                    y: player.y + ry
                }
            })
        } else if (i === 'a' || i === 'X') {
            const i2 = board[player.y + 2 * ry][player.x + 2 * rx];
            if (i2 === 'x' || i2 === ' ') {
                let newEocks = rocks;
                if (i2 === 'x') {
                    newEocks--;
                }
                if (i === 'X') {
                    newEocks++;
                }
                board[player.y + 2 * ry][player.x + 2 * rx] = i2 === ' ' ? 'a' : 'X';
                board[player.y + ry][player.x + rx] = i === 'X' ? 'x' : ' ';
                this.setState({
                    player: {
                        x: player.x + rx,
                        y: player.y + ry
                    },
                    board,
                    rocks: newEocks
                }, () => {
                    this.checkNextLevel();
                });
            }
        }
    };

    handleKeyDown = (e) => {
        switch (e.key) {
            case "ArrowLeft":
                this.movePlayer(-1, 0);
                break;
            case "ArrowRight":
                this.movePlayer(1, 0);
                break;
            case "ArrowDown":
                this.movePlayer(0, 1);
                break;
            case "ArrowUp":
                this.movePlayer(0, -1);
                break;
        }
    };

    restartLevel = () => {
        const {level} = this.state;
        this.initLevel(level);
        ReactDOM.findDOMNode(this.refs.board).focus();
    };

    nextLevel = () => {
        const {level} = this.state;

        if (level + 1 < levels.length) {
            this.setState({
                level: level + 1
            });
            this.initLevel(level + 1);
        }
        ReactDOM.findDOMNode(this.refs.board).focus();
    };

    setPassword = () => {
        const password = ReactDOM.findDOMNode(this.refs.pass).value;
        let level = null;
        for (let a=0; a<passwords.length; a++) {
            if (passwords[a] === password) {
                level = a;
                break;
            }
        }
        if (level !== null) {
            ReactDOM.findDOMNode(this.refs.pass).value = "";
            this.initLevel(level);
        }
    };

    newGame = () => {
        this.initLevel(0);
    };

    render() {
        const {rocks, level, player, board} = this.state;
        const items = [];

        if (board) {
            for (let y = 0; y < hh; y++) {
                for (let x = 0; x < ww; x++) {
                    const i = board[y][x];
                    const key = `${x},${y}`;
                    switch (i) {
                        case ' ':
                            items.push(<rect key={key} className="empty" width={pw} height={ph} x={x * pw} y={y * ph}></rect>);
                            break;
                        case '1':
                        case '2':
                        case '3':
                        case '4':
                            items.push(<g key={key}>
                                <g key={key} fill={`url(#g${i})`} filter={"url(#innerbevel)"} transform={`translate(${x * pw - 2},${y * ph + 16}) scale(0.0035,-0.0049)`}><path d="M281.8,3161.2c-179.9-93.8-183.7-118.7-178-901.5c5.7-629.7,7.7-656.5,45.9-708.2c21.1-28.7,68.9-72.7,103.4-95.7l63.2-44h1611.6h1611.6l63.2,44c34.4,23,82.3,67,103.4,95.7c38.3,53.6,40.2,74.7,40.2,750.3c0,673.8-1.9,696.7-40.2,748.4c-21.1,28.7-63.2,70.8-91.9,91.9c-51.7,40.2-70.8,40.2-1663.3,45.9C515.4,3191.8,333.5,3188,281.8,3161.2z"/><path d="M4272.7,3170.7c-26.8-11.5-68.9-38.3-91.9-61.2c-99.5-91.9-99.5-99.5-99.5-809.7v-664.2l45.9-80.4c90-153.1-15.3-145.5,1805-139.7c1604,5.7,1611.7,5.7,1665.2,45.9c28.7,23,70.8,68.9,91.9,105.3c36.4,61.2,38.3,99.5,38.3,735c0,637.4-1.9,673.8-38.3,736.9c-23,40.2-74.7,84.2-124.4,111l-84.2,42.1l-1581-1.9C4898.6,3189.9,4303.3,3182.2,4272.7,3170.7z"/><path d="M8215.6,3149.7c-49.8-26.8-101.4-70.8-124.4-111c-36.4-63.2-38.3-99.5-38.3-736.9c0-635.5,1.9-673.8,38.3-735c21-36.4,63.2-82.3,91.9-105.3c53.6-38.3,72.7-40.2,788.6-40.2c712,0,735,1.9,786.7,40.2c28.7,21.1,70.8,63.2,91.9,91.9c38.3,49.8,40.2,80.4,45.9,706.3c5.7,738.8,0,773.3-126.3,870.9l-67,51.7l-700.6,5.7C8305.6,3193.7,8301.8,3191.8,8215.6,3149.7z"/><path d="M339.3,992.5c-91.9-23-157-74.6-201-162.7C101.9,753.3,100,715,100,110.1c0-606.8,1.9-643.1,40.2-719.7c23-49.8,68.9-101.5,109.1-126.3c68.9-44,82.3-44,725.4-49.8c434.5-3.8,679.5,1.9,731.2,15.3c105.3,26.8,201,114.8,227.8,206.7c30.6,101.4,32.5,1253.7,1.9,1345.6c-32.5,97.6-124.4,183.8-220.1,206.7C1623.6,1011.7,435,1015.5,339.3,992.5z"/><path d="M2492.6,986.8c-88-24.9-187.6-120.6-210.5-206.7c-24.9-88-24.9-1253.7,0-1337.9c28.7-103.3,124.4-189.5,237.3-212.5c67-15.3,568.5-19.1,1638.4-15.3c1500.6,5.7,1542.7,7.6,1605.9,44c36.4,21.1,82.3,63.2,105.3,91.9c38.3,53.6,40.2,72.7,40.2,759.9s-1.9,706.3-40.2,759.9c-23,28.7-68.9,70.8-105.3,91.9c-63.2,38.3-103.4,38.3-1634.6,42.1C3131.9,1005.9,2534.7,1000.2,2492.6,986.8z"/><path d="M6475.7,990.6c-86.1-21.1-153.1-72.7-195.2-153.1c-32.5-61.3-36.4-120.6-36.4-723.5c0-614.4,1.9-660.3,38.3-729.3c21-42.1,68.9-95.7,109.1-118.7l72.7-45.9h1607.8h1607.8l70.8,44c40.2,24.9,86.1,76.6,109.1,126.3c38.3,76.6,40.2,112.9,40.2,719.7c0,606.8-1.9,643.1-40.2,719.7c-23,49.8-68.9,101.4-109.1,126.3l-70.8,44l-1569.5,3.8C7247.1,1005.9,6512.1,1000.2,6475.7,990.6z"/><path d="M281.8-1218.2c-70.8-30.6-134-99.5-160.8-170.3c-13.4-34.5-21.1-285.2-21.1-691c0-620.2,1.9-637.4,44-719.7c30.6-63.2,65.1-97.6,128.2-130.2l86.1-42.1l1602.1,3.8c1582.9,5.7,1602.1,5.7,1653.7,45.9c28.7,21.1,70.8,63.2,91.9,91.9c38.3,51.7,40.2,74.6,40.2,748.4c0,675.7-1.9,696.7-40.2,750.3c-21.1,28.7-68.9,72.7-103.4,97.6l-63.2,42.1H1939.4C649.3-1193.3,327.8-1197.1,281.8-1218.2z"/><path d="M4226.7-1235.4c-143.6-82.3-145.5-88.1-145.5-847.9c0-666.1,0-671.8,44-735c23-34.5,67-82.3,95.7-103.4c53.6-40.2,65.1-40.2,1646.1-45.9c1797.3-5.7,1711.2-11.5,1808.8,135.9l51.7,78.5v669.9c0,637.4-1.9,675.7-38.3,736.9c-21,36.4-63.2,82.3-91.9,105.3c-53.6,40.2-61.3,40.2-1674.8,44l-1621.2,5.7L4226.7-1235.4z"/><path d="M8223.3-1218.2c-74.7-32.5-135.9-111-160.8-206.7c-13.4-47.9-19.1-302.4-15.3-700.5c7.6-905.3-57.4-844.1,924.5-846c658.4,0,673.8,0,756.1,44c63.2,30.6,97.6,65.1,130.2,128.2c42.1,86.1,44,91.9,38.3,750.3c-5.7,639.3-7.6,666.1-45.9,717.8c-21.1,28.7-68.9,72.7-103.4,97.6c-63.2,42.1-68.9,42.1-763.7,42.1C8439.6-1193.3,8269.2-1199.1,8223.3-1218.2z"/></g>
                            </g>);
                            break;
                        case 'x':
                            items.push(<g key={key}>
                                <rect key="1" className="empty" width={pw} height={ph} x={x * pw} y={y * ph}></rect>
                                <path key="2" className="cross"
                                      d={`M${x * pw + 6},${y * ph + 6},${x * pw + pw - 6},${y * ph + ph - 6}z M${x * pw + 6},${y * ph + ph - 6},${x * pw + pw - 6},${y * ph + 6}z`}/>
                            </g>);
                            break;
                        case 'a':
                            items.push(<g key={key}>
                                <rect key={key} className="empty" width={pw} height={ph} x={x * pw} y={y * ph}></rect>
                                <g key={key + "a"} fill="black" transform={`translate(${x * pw - 2},${y * ph + 17}) scale(0.0035,-0.0028)`}><path d="M4039.3,4997.4c-502.5-43.5-1103.8-150.3-1438.2-257.2c-366-116.7-639-271-803.1-451c-221.6-245.3-251.2-567.7-71.2-763.6l73.2-79.1l7.9-1428.3l5.9-1426.3l-65.3-85.1C1645.7,368.4,1622,311,1612.1,182.4c-9.9-112.8-4-128.6,95-326.4l104.8-205.7l2-1366.9c2-995-2-1386.7-19.8-1446.1c-13.9-43.5-57.4-132.5-100.9-197.8c-75.2-112.8-77.2-122.7-77.2-284.9v-168.1l98.9-124.6c405.5-518.3,1426.3-811.1,2937.6-848.7c1537.1-35.6,2975.2,229.5,3434.1,631.1c128.6,112.8,243.3,282.9,267.1,393.7c37.6,178-19.8,395.6-136.5,518.3l-53.4,55.4l5.9,1408.5l5.9,1408.5l63.3,98.9c114.7,184,152.3,273,152.3,356.1c0,124.6-49.5,267-142.4,407.5l-85.1,126.6v751.7c0,413.4,4,1050.4,7.9,1416.4l5.9,666.6l67.2,65.3c75.2,73.2,126.6,213.6,126.6,342.2c0,45.5-25.7,148.4-55.4,231.5c-45.5,130.6-67.3,164.2-162.2,243.3c-261.1,223.5-512.4,342.2-959.4,457c-263.1,67.3-743.8,146.4-1167.1,187.9C5748.5,5009.2,4310.3,5021.1,4039.3,4997.4z M3600.2,4415.8c67.3-15.8,158.3-47.5,199.8-67.3c77.1-39.6,199.8-164.2,199.8-203.8c0-11.9-37.6-59.3-85.1-104.8c-128.6-128.6-241.3-156.3-615.2-142.4c-348.2,9.9-480.7,43.5-579.6,142.4c-35.6,35.6-65.3,79.1-65.3,96.9C2654.6,4358.4,3184.7,4512.7,3600.2,4415.8z M2245.1,3765c326.4-148.4,510.4-205.7,927.8-286.8c1076.1-209.7,2379.8-215.6,3556.8-19.8c435.2,73.2,662.7,140.5,987.1,292.8c166.2,77.1,308.6,140.5,318.5,140.5c9.9,0,7.9-25.7-2-57.4c-67.3-191.9-551.9-429.3-1125.6-551.9c-623.1-134.5-1545-195.8-2387.7-162.2c-565.8,23.7-937.7,63.3-1315.5,140.5c-682.5,138.5-1086,312.6-1232.4,536.1C1887,3925.2,1891,3923.2,2245.1,3765z M7754.4,1521.7c4-888.2,2-1641.9-5.9-1671.6c-17.8-67.3-120.7-122.7-387.7-207.7c-761.6-243.3-2435.2-366-3420.3-251.2c-367.9,41.5-838.8,122.6-1062.3,178c-174.1,45.5-609.3,223.5-753.7,312.6c-102.9,59.3-221.6,223.5-221.6,298.7c0,35.6,5.9,71.2,11.9,77.1c7.9,7.9,57.4-27.7,112.8-77.1c223.5-201.8,591.5-362,963.4-423.3c81.1-13.8,211.7-39.6,286.8-61.3c77.1-19.8,213.6-45.5,306.6-55.4c93-11.9,288.8-35.6,435.2-53.4c464.9-61.3,1774.4-45.5,2120.6,23.8l55.4,11.9l4,1574.6l5.9,1574.7l257.2,35.6c302.7,41.5,631.1,120.7,999,241.3c146.4,47.5,271,87,277,89C7744.5,3139.8,7752.4,2411.9,7754.4,1521.7z M7758.3-2175.6c0-858.5,5.9-1590.4,11.9-1630c15.8-93-25.7-132.5-259.1-245.3c-290.8-142.4-757.7-247.3-1374.9-310.6c-322.4-33.6-1636-33.6-1998,0c-1113.7,102.9-1766.5,271-2057.3,532.1c-100.9,89-176.1,213.6-178,288.8c0,47.5,31.7,41.5,94.9-15.8c156.3-148.4,364-251.3,712.1-358c443.1-134.6,985.2-223.6,1636-267.1c510.4-35.6,1667.6-2,1825.9,51.4c17.8,5.9,23.7,340.3,23.7,1580.6v1574.7l45.5,9.9c23.7,5.9,189.9,27.7,366,49.5c407.5,49.5,526.2,77.1,844.7,197.8c142.4,51.4,269,96.9,282.9,96.9C7752.4-618.7,7758.3-943.2,7758.3-2175.6z"></path></g>
                            </g>);
                            break;
                        case 'X':
                            items.push(<g key={key}>
                                <rect key={key} className="empty" width={pw} height={ph} x={x * pw} y={y * ph}></rect>
                                <g key={key + "a"} fill="green" transform={`translate(${x * pw - 2},${y * ph + 17}) scale(0.0035,-0.0028)`}><path d="M4039.3,4997.4c-502.5-43.5-1103.8-150.3-1438.2-257.2c-366-116.7-639-271-803.1-451c-221.6-245.3-251.2-567.7-71.2-763.6l73.2-79.1l7.9-1428.3l5.9-1426.3l-65.3-85.1C1645.7,368.4,1622,311,1612.1,182.4c-9.9-112.8-4-128.6,95-326.4l104.8-205.7l2-1366.9c2-995-2-1386.7-19.8-1446.1c-13.9-43.5-57.4-132.5-100.9-197.8c-75.2-112.8-77.2-122.7-77.2-284.9v-168.1l98.9-124.6c405.5-518.3,1426.3-811.1,2937.6-848.7c1537.1-35.6,2975.2,229.5,3434.1,631.1c128.6,112.8,243.3,282.9,267.1,393.7c37.6,178-19.8,395.6-136.5,518.3l-53.4,55.4l5.9,1408.5l5.9,1408.5l63.3,98.9c114.7,184,152.3,273,152.3,356.1c0,124.6-49.5,267-142.4,407.5l-85.1,126.6v751.7c0,413.4,4,1050.4,7.9,1416.4l5.9,666.6l67.2,65.3c75.2,73.2,126.6,213.6,126.6,342.2c0,45.5-25.7,148.4-55.4,231.5c-45.5,130.6-67.3,164.2-162.2,243.3c-261.1,223.5-512.4,342.2-959.4,457c-263.1,67.3-743.8,146.4-1167.1,187.9C5748.5,5009.2,4310.3,5021.1,4039.3,4997.4z M3600.2,4415.8c67.3-15.8,158.3-47.5,199.8-67.3c77.1-39.6,199.8-164.2,199.8-203.8c0-11.9-37.6-59.3-85.1-104.8c-128.6-128.6-241.3-156.3-615.2-142.4c-348.2,9.9-480.7,43.5-579.6,142.4c-35.6,35.6-65.3,79.1-65.3,96.9C2654.6,4358.4,3184.7,4512.7,3600.2,4415.8z M2245.1,3765c326.4-148.4,510.4-205.7,927.8-286.8c1076.1-209.7,2379.8-215.6,3556.8-19.8c435.2,73.2,662.7,140.5,987.1,292.8c166.2,77.1,308.6,140.5,318.5,140.5c9.9,0,7.9-25.7-2-57.4c-67.3-191.9-551.9-429.3-1125.6-551.9c-623.1-134.5-1545-195.8-2387.7-162.2c-565.8,23.7-937.7,63.3-1315.5,140.5c-682.5,138.5-1086,312.6-1232.4,536.1C1887,3925.2,1891,3923.2,2245.1,3765z M7754.4,1521.7c4-888.2,2-1641.9-5.9-1671.6c-17.8-67.3-120.7-122.7-387.7-207.7c-761.6-243.3-2435.2-366-3420.3-251.2c-367.9,41.5-838.8,122.6-1062.3,178c-174.1,45.5-609.3,223.5-753.7,312.6c-102.9,59.3-221.6,223.5-221.6,298.7c0,35.6,5.9,71.2,11.9,77.1c7.9,7.9,57.4-27.7,112.8-77.1c223.5-201.8,591.5-362,963.4-423.3c81.1-13.8,211.7-39.6,286.8-61.3c77.1-19.8,213.6-45.5,306.6-55.4c93-11.9,288.8-35.6,435.2-53.4c464.9-61.3,1774.4-45.5,2120.6,23.8l55.4,11.9l4,1574.6l5.9,1574.7l257.2,35.6c302.7,41.5,631.1,120.7,999,241.3c146.4,47.5,271,87,277,89C7744.5,3139.8,7752.4,2411.9,7754.4,1521.7z M7758.3-2175.6c0-858.5,5.9-1590.4,11.9-1630c15.8-93-25.7-132.5-259.1-245.3c-290.8-142.4-757.7-247.3-1374.9-310.6c-322.4-33.6-1636-33.6-1998,0c-1113.7,102.9-1766.5,271-2057.3,532.1c-100.9,89-176.1,213.6-178,288.8c0,47.5,31.7,41.5,94.9-15.8c156.3-148.4,364-251.3,712.1-358c443.1-134.6,985.2-223.6,1636-267.1c510.4-35.6,1667.6-2,1825.9,51.4c17.8,5.9,23.7,340.3,23.7,1580.6v1574.7l45.5,9.9c23.7,5.9,189.9,27.7,366,49.5c407.5,49.5,526.2,77.1,844.7,197.8c142.4,51.4,269,96.9,282.9,96.9C7752.4-618.7,7758.3-943.2,7758.3-2175.6z"></path></g>
                            </g>);
                            break;
                    }
                }
            }
        }

        return <div className="sokoban">
            <div className="actions">
                <button onClick={this.restartLevel}>Restart levelu</button>
                Zadat heslo: <input ref="pass" type="text"/><button onClick={this.setPassword}>OK</button>
                <button onClick={this.newGame}>Začít novou hru</button>
            </div>
            Level {level + 1}/{levels.length}, zbývá umístit {rocks}, heslo: {passwords[level]}
            <div className="game">
                <svg className={"board"} ref="board" tabIndex="0" onKeyDown={this.handleKeyDown} style={{width: ww * pw, height: hh * ph}} version="1.1" xmlns="http://www.w3.org/2000/svg">
                    {this.renderGradients()}
                    {items}
                    {player && this.renderPlayer(player)}
                </svg>
            </div>
        </div>
    }
}
